export default "__VITE_ASSET__D2KQb0r1__"